// extracted by mini-css-extract-plugin
export default {"contenedor":"CampoBuscarPersona_contenedor__69eMk","boton":"CampoBuscarPersona_boton__OyF+I"};